<template>
  <div class="payment-result">
    <div class="row justify-content-center">
      <div class="col-md-6 mb-3">
        <img
          src="prslogo.png"
          alt="prslogo.png"
        >
      </div>
      <div
        class="col-md-8"
        :class="isSuccess ? 'text-success' : 'text-danger'"
      >
        <h2>{{ isSuccess ? 'Ödemeniz Başarıyla Alındı' : 'Ödeme Başarısız' }}</h2>
        <p v-if="message">
          {{ message }}
        </p>
        <p v-if="orderRef">
          Sipariş No: {{ orderRef }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentResult',
  computed: {
    isSuccess() {
      return this.$route.query.status === 'success';
    },
    message() {
      return this.$route.query.message || '';
    },
    orderRef() {
      return this.$route.query.orderRef || '';
    },
  },
};
</script>

<style>
.payment-result {
  padding-top: 40px;
  text-align: center;
}
</style>
